@if (metricsExist()) {
  <div class="widget-content">
    <h3 class="widget-title">{{ 'Metrics Widget' | translate }}</h3>
    @if (hasDownLineUsers()) {
      <div class="widget-search">
        <form
          [formGroup]="widgetFormGroup" class="flex-form">
          <app-user-autocomplete #userAutocomplete
            [formGroup]="widgetFormGroup"
            [required]="false"
            (userChanged)="onUserSelected($event)"
          ></app-user-autocomplete>
        </form>
      </div>
    }
    <div class="widget-table">
      <div class="widget-row widget-header">
        <div class="widget-row__title">{{ widgetHeaderData[0] | async }}</div>
        @if (myMetricsExist()) {
          <div class="widget-row__item">{{ widgetHeaderData[1] | async }}</div>
        }
        @if (teamMetricsExist()) {
          <div class="widget-row__item">{{ widgetHeaderData[2] | async }}</div>
        }
      </div>
      <div class="widget-data">
        @for (row of widgetData; track row) {
          <div class="widget-row">
            <div class="widget-row__title">{{ row.title | translate }} </div>
            @if (myMetricsExist()) {
              <div class="widget-row__item">{{ row.myGoals }} </div>
            }
            @if (teamMetricsExist()) {
              <div class="widget-row__item">{{ row.teamGoals }}</div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
